// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qv-c";
export var backButton = "_qv-4";
export var backIcon = "_qv-5";
export var chevronShortcut = "_qv-6";
export var container = "_qv-1";
export var editor = "_qv-8";
export var editorWrapper = "_qv-7";
export var prefix = "_qv-2";
export var searchIcon = "_qv-3";
export var suffix = "_qv-9";
export var suffixContent = "_qv-a";
export var suffixText = "_qv-b";
export var wrapper = "_qv-0";